module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper willmustlist pt-header65"
  }, [_c('header', {
    staticClass: "gheader -white gheader-fix"
  }, [_c('div', {
    staticClass: "gheader__link-back"
  }, [_c('a', {
    on: {
      "click": _vm.goTop
    }
  }, [_vm._v("戻る")])])]), _c('div', {
    staticClass: "treatment__container"
  }, [_c('div', {
    staticClass: "row bg04"
  }, [_vm._m(0), _c('div', {
    staticClass: "treatment__tabs"
  }, [_c('ul', {
    staticClass: "treatment__tabs__wrap"
  }, [_c('li', {
    staticClass: "treatment__tabs__item -salary",
    on: {
      "click": function($event) {
        _vm.goTreatmentSalaryList()
      }
    }
  }, [_c('span', [_vm._v("給与関連")])]), _c('li', {
    staticClass: "treatment__tabs__item -leave",
    on: {
      "click": function($event) {
        _vm.goTreatmentLeaveList()
      }
    }
  }, [_c('span', [_vm._v("休暇関連")])]), _vm._m(1)])])]), _c('div', {
    staticClass: "treatment__tab-body"
  }, [_c('div', {
    staticClass: "treatment__tab-contents"
  }, [_vm._m(2), _vm._m(3), _c('h2', {
    staticClass: "treatment__tab-heading"
  }, [_vm._v("寮生活")]), _c('div', {
    staticClass: "treatment__tab-buttons"
  }, [_c('button', {
    staticClass: "btn01_treatment",
    on: {
      "click": function($event) {
        _vm.goTreatmentDetail('domitory')
      }
    }
  }, [_vm._v("社員寮")]), _vm._m(4)]), _vm._m(5), _c('h2', {
    staticClass: "treatment__tab-heading"
  }, [_vm._v("スキルアップ")]), _c('div', {
    staticClass: "treatment__tab-buttons"
  }, [_c('button', {
    staticClass: "btn01_treatment",
    on: {
      "click": function($event) {
        _vm.goTreatmentDetail('jump')
      }
    }
  }, [_vm._v("JUMP")]), _c('button', {
    staticClass: "btn01_treatment",
    on: {
      "click": function($event) {
        _vm.goTreatmentDetail('step_up_system')
      }
    }
  }, [_vm._v("ステップアップ制度")]), _c('button', {
    staticClass: "btn01_treatment",
    on: {
      "click": function($event) {
        _vm.goTreatmentDetail('wonder_ college')
      }
    }
  }, [_vm._v("ワンダーカレッジ")]), _vm._m(6)]), _vm._m(7), _c('h2', {
    staticClass: "treatment__tab-heading"
  }, [_vm._v("コミュニケーション")]), _c('div', {
    staticClass: "treatment__tab-buttons"
  }, [_c('button', {
    staticClass: "btn01_treatment",
    on: {
      "click": function($event) {
        _vm.goTreatmentDetail('ESmycard')
      }
    }
  }, [_vm._v("ESmyカード")]), _c('button', {
    staticClass: "btn01_treatment",
    on: {
      "click": function($event) {
        _vm.goTreatmentDetail('syaraku')
      }
    }
  }, [_vm._v("sya楽")])]), _vm._m(8), _c('h2', {
    staticClass: "treatment__tab-heading"
  }, [_vm._v("会社向上")]), _c('div', {
    staticClass: "treatment__tab-buttons"
  }, [_c('button', {
    staticClass: "btn01_treatment",
    on: {
      "click": function($event) {
        _vm.goTreatmentDetail('proposal_system')
      }
    }
  }, [_vm._v("社内提案制度")]), _c('button', {
    staticClass: "btn01_treatment",
    on: {
      "click": function($event) {
        _vm.goTreatmentDetail('referral_system')
      }
    }
  }, [_vm._v("友達紹介制度")]), _c('button', {
    staticClass: "btn01_treatment",
    on: {
      "click": function($event) {
        _vm.goTreatmentDetail('wonder_award')
      }
    }
  }, [_vm._v("ワンダー栄誉賞")]), _vm._m(9)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__heading"
  }, [_c('h2', {
    staticClass: "treatment__heading__title"
  }, [_c('span', {
    staticClass: "treatment__heading__img"
  }, [_c('div', {
    staticClass: "heading_01-treatment"
  }, [_vm._v("待遇・制度の一覧だニャン！")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "treatment__tabs__item -rule -active"
  }, [_c('span', [_vm._v("制度関連")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__tab-notice"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_cat_02.png"),
      "alt": "",
      "width": "48px",
      "height": "42px"
    }
  }), _c('h2', {
    staticClass: "treatment__tab-notice-baloon"
  }, [_vm._v("わからないことは、店長へ相談・確認してくれニャン！")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__icons"
  }, [_c('img', {
    attrs: {
      "src": require("../images/icon_domitory.png"),
      "alt": "",
      "width": "16px",
      "height": "16px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__tab-comment"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_cat_03.png"),
      "alt": "",
      "width": "32px",
      "height": "42px"
    }
  }), _c('span', [_vm._v("単身者はすごく助かるニャン")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__icons"
  }, [_c('img', {
    attrs: {
      "src": require("../images/icon_up.png"),
      "alt": "",
      "width": "16px",
      "height": "16px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__tab-comment"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_cat_05.png"),
      "alt": "",
      "width": "42px",
      "height": "42px"
    }
  }), _c('span', [_vm._v(" 自分の価値を高めるニャン")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__icons"
  }, [_c('img', {
    attrs: {
      "src": require("../images/icon_handshake.png"),
      "alt": "",
      "width": "16px",
      "height": "16px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__icons"
  }, [_c('img', {
    attrs: {
      "src": require("../images/icon_company.png"),
      "alt": "",
      "width": "16px",
      "height": "16px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "treatment__tab-comment"
  }, [_c('img', {
    attrs: {
      "src": require("../images/img_cat_43.png"),
      "alt": "",
      "width": "42px",
      "height": "42px"
    }
  }), _c('span', [_vm._v("仲間と共に仕事を楽しむニャン")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-77591705!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/treatment-rule-list.pug
// module id = 1418
// module chunks = 1